import API from 'services/api';

export const updateDefaultCustomFilter = ({
  filterId,
  isDefault,
}: {
  filterId: string | null | undefined;
  isDefault?: boolean;
}) => {
  if (filterId && typeof isDefault === 'boolean') {
    return API.put(`/api/users/filters/${filterId}/set-default`, null, {
      params: { isDefault: isDefault },
    });
  } else {
    return API.put(`/api/users/filters/${filterId}/set-default`);
  }
};
